module.exports = __webpack_public_path__ + "img/canals5d-svs@2x.30fbd20a.png";